import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

import { AnalyticsService } from '../../../shared/services/analytics.service';

import { OrderHistoryLine } from '../../models/orderhistoryline';

@Component({
  selector: 'app-orderhistorylines-line',
  templateUrl: './orderhistorylines-line.component.html',
  styleUrls: ['./orderhistorylines-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderhistorylinesLineComponent {
  @Input() line: OrderHistoryLine
  @Input() isInCart: boolean
  @Input() isReOrderable: boolean
  @Input() currency: string

  @Output() onReOrder = new EventEmitter<string>()

  constructor(private analyticsSvc: AnalyticsService) { }

  get hasDesc(): boolean {
    return !!this.line.productDesc
  }

  get relativeQuantity(): number {
    return this.line.quantity / this.line.stepping
  }

  get absoluteQuantity(): number {
    return this.line.quantity
  }

  get thumbnail(): string {
    const thumb = this.line.productImgs.find(img => img.type === 'thumb')
    if (thumb && thumb.src) {
      return thumb.src
    }

    // No thumb, return default no-image-placeholder
    return '/assets/images/no-image-placeholder.png'
  }

  get isProductOrderable(): boolean {
    return this.isReOrderable;
  }

  get productId(): string {
    return this.line.currentProduct.length > 0
      ? this.line.currentProduct[0]._id
      : ''
  }

  reOrder(): void {
    this.analyticsSvc.event('click', { event_category: 'Orderhistory', event_label: 'Re-Order'});
    this.onReOrder.emit(this.productId)
  }
}
